import {round} from 'lodash'

export default {
  methods: {
    getFileSize (value) {
      let result
      switch (true) {
      case (value > 1048576 && value < 1073741824):
        result = round(value / 1048576, 1) + ' MB'
        break
      case (value > 1073741824):
        result = round(value / 1073741824, 1) + ' GB'
        break
      default:
        result = round(value / 1024, 1) + ' KB'
        break
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getFileSize.js